<div class="bottom-sheet">
    <div [innerHTML]="title"> </div>
    <button mat-button type="button" class="close" color="warn" (click)="clearBar()">Cerrar</button>
    <button *ngIf="undone" mat-button class="change" type="submit" color="warn" (click)="undoneActions()">Deshacer</button>
  </div>

